import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "top-bar" }
const _hoisted_2 = { class: "top-bar-start" }
const _hoisted_3 = { class: "top-bar-end" }
const _hoisted_4 = { class: "user-section" }
const _hoisted_5 = { class: "sidebar-content" }
const _hoisted_6 = { class: "menu-section" }
const _hoisted_7 = { class: "menu-label" }
const _hoisted_8 = {
  key: 0,
  class: "menu-section"
}
const _hoisted_9 = { class: "menu-header" }
const _hoisted_10 = { class: "menu-label" }
const _hoisted_11 = { class: "flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_p_button = _resolveComponent("p-button")!
  const _component_Halo = _resolveComponent("Halo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SandBox = _resolveComponent("SandBox")!
  const _component_p_dialog = _resolveComponent("p-dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_p_button, {
          icon: "pi pi-bars",
          onClick: _ctx.toggleSidebar,
          text: "",
          rounded: "",
          class: "sidebar-toggle"
        }, null, 8, ["onClick"]),
        _cache[8] || (_cache[8] = _createElementVNode("a", {
          href: "/",
          class: "logo-container"
        }, [
          _createElementVNode("img", {
            alt: "logo",
            src: _imports_0,
            height: "40"
          })
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Halo, {
          env: _ctx.env,
          home_url: _ctx.home_url
        }, null, 8, ["env", "home_url"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_p_button, {
            type: "button",
            label: _ctx.user.role,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sandboxDialog = true)),
            icon: "pi pi-user",
            class: "role-btn",
            text: ""
          }, null, 8, ["label"]),
          _withDirectives(_createVNode(_component_p_button, {
            type: "button",
            label: "Help",
            icon: "pi pi-question-circle",
            class: "help-btn",
            onClick: _ctx.openUserManual,
            text: ""
          }, null, 8, ["onClick"]), [
            [_directive_tooltip, 'User Manual & Help']
          ]),
          _createVNode(_component_p_button, {
            type: "button",
            label: "Logout",
            icon: "pi pi-sign-out",
            class: "logout-btn",
            onClick: _ctx.logout,
            severity: "danger",
            text: ""
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["sidebar", { 'sidebar-collapsed': !_ctx.sidebarVisible }])
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainMenuItems, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.label,
              to: item.to,
              class: _normalizeClass(["menu-item", { 'active': _ctx.$route.path === item.to }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sidebarVisible = false))
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(item.icon)
                }, null, 2),
                _createElementVNode("span", _hoisted_7, _toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128))
        ]),
        (_ctx.isAdminUser)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[9] || (_cache[9] = _createElementVNode("i", { class: "pi pi-fw pi-wrench" }, null, -1)),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "menu-label" }, "Admin", -1)),
                _createElementVNode("i", {
                  class: _normalizeClass(["pi pi-fw pi-angle-down toggle-icon", { 'expanded': _ctx.adminExpanded }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.adminExpanded = !_ctx.adminExpanded))
                }, null, 2)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["submenu", { 'submenu-collapsed': !_ctx.adminExpanded }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adminMenuItems, (item) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: item.label,
                    to: item.to,
                    class: _normalizeClass(["menu-item submenu-item", { 'active': _ctx.$route.path === item.to }]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sidebarVisible = false))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        class: _normalizeClass(item.icon)
                      }, null, 2),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                }), 128))
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (_ctx.sidebarVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "sidebar-overlay",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sidebarVisible = false))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_p_dialog, {
      visible: _ctx.sandboxDialog,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sandboxDialog) = $event)),
      modal: "",
      header: "Edit Sandbox User",
      style: { width: '700px' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SandBox)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_p_dialog, {
      visible: _ctx.showHelpDialog,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showHelpDialog) = $event)),
      modal: "",
      header: "SimForce User Manual & Help",
      style: { width: '90vw', height: '90vh' }
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _cache[11] || (_cache[11] = _createElementVNode("div", null, [
            _createElementVNode("small", { class: "text-muted" }, "SimForce Enhanced Leave Management System")
          ], -1)),
          _createElementVNode("div", null, [
            _createVNode(_component_p_button, {
              label: "Close",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showHelpDialog = false))
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "help-content" }, [
          _createElementVNode("div", { class: "grid" }, [
            _createElementVNode("div", { class: "col-12 md:col-4" }, [
              _createElementVNode("div", { class: "help-section" }, [
                _createElementVNode("h4", null, "🚀 Getting Started"),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Login:"),
                    _createTextVNode(" Use your company email and password")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Dashboard:"),
                    _createTextVNode(" Overview of your leave balances and recent activity")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Apply Leave:"),
                    _createTextVNode(" Click \"Apply for Leave\" for standard requests")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "AI Apply:"),
                    _createTextVNode(" Use \"AI Apply\" for smart recommendations")
                  ])
                ])
              ]),
              _createElementVNode("div", { class: "help-section" }, [
                _createElementVNode("h4", null, "🤖 AI Features"),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Smart Validation:"),
                    _createTextVNode(" Real-time leave request analysis")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Approval Prediction:"),
                    _createTextVNode(" Likelihood of approval based on history")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Risk Assessment:"),
                    _createTextVNode(" Team impact and business risk factors")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Date Recommendations:"),
                    _createTextVNode(" Optimal timing suggestions")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", { class: "col-12 md:col-4" }, [
              _createElementVNode("div", { class: "help-section" }, [
                _createElementVNode("h4", null, "📝 Leave Application Process"),
                _createElementVNode("ol", null, [
                  _createElementVNode("li", null, [
                    _createTextVNode("Navigate to "),
                    _createElementVNode("strong", null, "Leave Management")
                  ]),
                  _createElementVNode("li", null, [
                    _createTextVNode("Click "),
                    _createElementVNode("strong", null, "\"Apply for Leave\"")
                  ]),
                  _createElementVNode("li", null, "Select leave type and dates"),
                  _createElementVNode("li", null, [
                    _createTextVNode("Use "),
                    _createElementVNode("strong", null, "\"AI Analysis\""),
                    _createTextVNode(" for recommendations")
                  ]),
                  _createElementVNode("li", null, "Fill in reason and contact details"),
                  _createElementVNode("li", null, "Submit your application")
                ])
              ]),
              _createElementVNode("div", { class: "help-section" }, [
                _createElementVNode("h4", null, "👨‍💼 For Managers"),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Pending Approvals:"),
                    _createTextVNode(" Review team leave requests")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "AI Insights:"),
                    _createTextVNode(" Use AI recommendations for decisions")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Team Calendar:"),
                    _createTextVNode(" View team availability")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Delegation:"),
                    _createTextVNode(" Set up proxy approvers")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", { class: "col-12 md:col-4" }, [
              _createElementVNode("div", { class: "help-section" }, [
                _createElementVNode("h4", null, "⚙️ Admin Features"),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Leave Rules:"),
                    _createTextVNode(" Configure business validation rules")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Approval Flows:"),
                    _createTextVNode(" Set up approval workflows")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Analytics:"),
                    _createTextVNode(" Monitor system performance")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "User Management:"),
                    _createTextVNode(" Manage employee accounts")
                  ])
                ])
              ]),
              _createElementVNode("div", { class: "help-section" }, [
                _createElementVNode("h4", null, "📱 Mobile App"),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Leave Dashboard:"),
                    _createTextVNode(" Quick access to balances")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "AI Features:"),
                    _createTextVNode(" Smart leave applications")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Notifications:"),
                    _createTextVNode(" Real-time approval updates")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("strong", null, "Offline Support:"),
                    _createTextVNode(" Basic functionality without internet")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", { class: "col-12" }, [
              _createElementVNode("div", { class: "help-section" }, [
                _createElementVNode("h4", null, "🔗 Approval Workflows"),
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, "How workflows are automatically attached to your leave:")
                ]),
                _createElementVNode("div", { class: "grid" }, [
                  _createElementVNode("div", { class: "col-md-6" }, [
                    _createElementVNode("h6", null, "Automatic Selection:"),
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "1-7 days Annual:"),
                        _createTextVNode(" Manager approval (48h)")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "8+ days Annual:"),
                        _createTextVNode(" Manager → RSM approval")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "Medical Leave:"),
                        _createTextVNode(" Manager + HR (parallel)")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "Emergency:"),
                        _createTextVNode(" Auto-approved immediately")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "Mandatory:"),
                        _createTextVNode(" Auto-approved (BFSI compliance)")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-md-6" }, [
                    _createElementVNode("h6", null, "Workflow Features:"),
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "Smart Selection:"),
                        _createTextVNode(" Based on type + duration")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "Transparent Process:"),
                        _createTextVNode(" See approval steps")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "Timeout Protection:"),
                        _createTextVNode(" Auto-escalation")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "Delegation Support:"),
                        _createTextVNode(" Proxy approvers")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "Compliance Built-in:"),
                        _createTextVNode(" Regulatory requirements")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", { class: "workflow-examples mt-3" }, [
                  _createElementVNode("h6", null, "Example Workflow Process:"),
                  _createElementVNode("div", { class: "workflow-example" }, [
                    _createElementVNode("strong", null, "3-Day Annual Leave:"),
                    _createElementVNode("div", { class: "workflow-steps" }, " Submit → Manager Review (48h) → Approved ✅ ")
                  ]),
                  _createElementVNode("div", { class: "workflow-example" }, [
                    _createElementVNode("strong", null, "10-Day Annual Leave:"),
                    _createElementVNode("div", { class: "workflow-steps" }, " Submit → Manager (48h) → RSM (72h) → Approved ✅ ")
                  ]),
                  _createElementVNode("div", { class: "workflow-example" }, [
                    _createElementVNode("strong", null, "Emergency Leave:"),
                    _createElementVNode("div", { class: "workflow-steps" }, " Submit → Auto-Approved ⚡ (with notification) ")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", { class: "col-12" }, [
              _createElementVNode("div", { class: "help-section" }, [
                _createElementVNode("h4", null, "🛠️ Troubleshooting"),
                _createElementVNode("div", { class: "grid" }, [
                  _createElementVNode("div", { class: "col-md-6" }, [
                    _createElementVNode("h6", null, "Common Issues:"),
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "\"Insufficient balance\":"),
                        _createTextVNode(" Check your available leave days")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "\"Team coverage low\":"),
                        _createTextVNode(" Choose alternative dates")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "\"Documentation required\":"),
                        _createTextVNode(" Upload supporting documents")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "\"Workflow not found\":"),
                        _createTextVNode(" Contact admin for workflow setup")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-md-6" }, [
                    _createElementVNode("h6", null, "Getting Help:"),
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "Technical Issues:"),
                        _createTextVNode(" Contact IT Helpdesk")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "Leave Policies:"),
                        _createTextVNode(" Contact HR Department")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "Workflow Questions:"),
                        _createTextVNode(" Check Admin → Approval Flows")
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("strong", null, "System Training:"),
                        _createTextVNode(" Contact your manager")
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ], -1))
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}